
import Vue from 'vue'
import { QInput, QSelect } from 'quasar'
import gql from 'graphql-tag'
import { Notify } from 'quasar'
export default Vue.extend({
    components: { QInput, QSelect },
    props: {
        listId: {
          type: String
        },
        listName: {
          type: String
        }
    },
    data() {
      return {
        name: '',
        password: '',
        isLoading: false,
        isSucesss: false
      }
    },

    methods: <any>{
      async submit(): Promise<void> {
        this.isLoading = true
        try {
          const { data } = await this.$apollo.mutate({
            mutation: gql`
              mutation create ($name: String!, $password: String!, $parentId: String!) {
                createList(name: $name, password: $password, parentId: $parentId) {
                    id
                }
              }
            `,
            variables: {
              name: this.name,
              password: this.password,
              parentId: this.listId 
            }
          })
          this.isLoading = false
          this.isSucesss = true
          setTimeout( () => {
              this.$emit('closeDialog')
          }, 2500)
        } catch(err) {
            this.isLoading = false

            Notify.create({
                message: err.graphQLErrors ? err.graphQLErrors[0].message : err.message,
                color: 'red'
            })
        }
      },
    },
    computed: {
        isValid() {
            if(!this.password) return false
            if(!this.name) return false
            return true
        }
    }
})

